import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { UserProvider, UserContext } from "./contexts/UserContext";
import ReCaptchaWrapper from "./components/ReCaptchaWrapper";
import { SnackbarProvider } from "notistack";
import LoginPage from "./modules/login/pages/LoginPage";
import ForgotPasswordPage from "./modules/login/pages/ForgotPasswordPage";
import ChangePasswordPage from "./modules/login/pages/ChangePasswordPage";
import ResetPasswordPage from "./modules/login/pages/ResetPasswordPage";
import DashboardPage from "./modules/dashboard/pages/DashboardPage";
import DocumentStatusPage from "./modules/admin/pages/DocumentStatusPage";
import ModificarContratoDigitalPage from "./modules/admin/pages/ModificarContratoDigitalPage";
import ContratoDigitalPage from "./modules/admin/pages/ContratoDigitalPage";
import DarDeBaja from "./modules/admin/pages/DarDeBajaPage";
import IngresarVentasPage from "./modules/ventas/pages/IngresarVentasPage";
import FirmantesPage from "./modules/admin/pages/FirmantesPage";
import ProtectedRoute from "./contexts/ProtectedRoute";

// Importa los componentes de layout
import Header from "./components/Header";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import ContentContainer from "./components/ContentContainer";

function App() {
  // Componente envoltorio para componentes con layout completo
  const WithLayoutWrapper = ({ Component }) => {
    const { roleId } = useContext(UserContext);
    return (
      <div className="dashboard-container">
        <Header />
        <div className="content-area">
          <Menu role_id={roleId} />
          <div className="page-container">
            <ContentContainer>
              <Component />
            </ContentContainer>
          </div>
        </div>
        <Footer />
      </div>
    );
  };

  return (
    <SnackbarProvider maxSnack={3}>
      <Router>
        <UserProvider>
          <ReCaptchaWrapper>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
              <Route
                path="/changepassword/:token"
                element={<ChangePasswordPage />}
              />
              <Route
                path="/resetpassword/:token"
                element={<ResetPasswordPage />}
              />
              <Route path="/dashboard" element={<DashboardPage />} />

              {/* Rutas protegidas - Especificamos los roles permitidos */}
              <Route
                path="/contratos"
                element={
                  <ProtectedRoute
                    element={ContratoDigitalPage}
                    allowedRoles={[1, 2, 4]}
                  />
                }
              />
              <Route
                path="/dar-de-baja"
                element={
                  <ProtectedRoute
                    element={DarDeBaja}
                    allowedRoles={[1, 2, 4]}
                  />
                }
              />
              <Route
                path="/document-status"
                element={
                  <ProtectedRoute
                    element={DocumentStatusPage}
                    allowedRoles={[1, 2, 4]}
                  />
                }
              />
              <Route
                path="/modificacion-de-plan"
                element={
                  <ProtectedRoute
                    element={ModificarContratoDigitalPage}
                    allowedRoles={[1, 2, 4]}
                  />
                }
              />
              <Route
                path="/ingresar-venta"
                element={
                  <ProtectedRoute
                    element={() => (
                      <WithLayoutWrapper Component={IngresarVentasPage} />
                    )}
                    allowedRoles={[1, 2, 3, 4]} // Explícitamente permitimos rol 4
                  />
                }
              />
              {/* Firmantes ahora se maneja desde el Dashboard */}
              <Route
                path="/firmantes"
                element={<Navigate to="/dashboard?page=Firmantes" replace />}
              />

              {/* Redirige cualquier ruta no encontrada al LoginPage */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ReCaptchaWrapper>
        </UserProvider>
      </Router>
    </SnackbarProvider>
  );
}

export default App;
